document.addEventListener("DOMContentLoaded", function () {
  if (document.getElementById("featured-properties")) {
    var splide = new Splide(".featured-properties", {
      pagination: false,
      type: "slide",
      perMove: 1,
      snap: true,
      drag: "free",
      gap: "30px",
      fixedWidth: "499px",
      lazyLoad: "nearby",
      arrows: true,
      arrowPath: "", // Disable default arrow SVG path
      classes: {
        arrows: "custom-arrows", // Class for the arrows wrapper
        arrow: "custom-arrow", // Class for both arrows
        prev: "custom-prev", // Class for the previous arrow
        next: "custom-next", // Class for the next arrow
      },
    });
    splide.mount();
  }
  if (document.getElementById("corporate-response")) {
    var splide = new Splide(".cr-sustainable-slider", {
      pagination: false,
      autoplay: true,
      Interval: 2500,
      type: "loop",
      perMove: 1,
      snap: true,
      drag: "free",
      lazyLoad: "nearby",
      arrows: true,
    });
    splide.mount();

    var govSplide = new Splide(".cr-sub-governance-slider", {
      pagination: false,
      autoplay: true,
      Interval: 2500,
      type: "slide",
      perMove: 1,
      snap: true,
      fixedWidth: "100%",
      padding: "20%",
      gap: "13%",
      drag: true,
      rewind: true,
      lazyLoad: "nearby",
      arrows: false,
      focus: "center",
      breakpoints: {
        640: {
          padding: "10%",
        },
      },
    });

    govSplide.mount();

    var customPaginationButtons = document.querySelectorAll(
      ".custom-pagination-button"
    );

    customPaginationButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        var slideIndex = parseInt(this.getAttribute("data-slide"));
        govSplide.go(slideIndex);
      });
    });

    govSplide.on("move", function (newIndex) {
      customPaginationButtons.forEach(function (button) {
        button.classList.remove("is-active");
      });
      customPaginationButtons[newIndex].classList.add("is-active");
    });

    customPaginationButtons[govSplide.index].classList.add("is-active");
  }
});
